<div rlChecklist [formControl]="formControl" #checklist="rlChecklist" class="checklist">
  @if(showSelectAll()){
    <div class="form-check ms-1">
      <input type="checkbox" class="form-check-input" [formControl]="checklist.selectAllFC" data-cy="selectAll" />
      <label class="ms-1 form-check-label text-nowrap">
        Select all
      </label>
    </div>
  }
  @if (kvps().length) {
    <div class="ms-1" [class.scroll-box]="!disableScroll" [class.border-top]="disableScroll">
      @for(kvp of kvps(); track kvp[0]){
        <div class="form-check">
          <input type="checkbox" class="form-check-input" [rlChecklistItem]="kvp[0]"
            [attr.data-cy]="kvp[1] | trimWhitespace" />
          <label class="ms-1 form-check-label text-nowrap" [innerText]="kvp[1]"></label>
        </div>
      }
    </div>
  }
</div>